import { z } from 'zod';

const ALIAS_REGEX = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

// Mirrors backend CreateClubDto constraints exactly
export const clubOnboardingSchema = z.object({
  name: z.string().trim().min(1, 'Le nom du club est requis').max(100, 'Le nom ne peut pas dépasser 100 caractères'),
  alias: z
    .string()
    .trim()
    .min(1, "L'alias est requis")
    .max(100, "L'alias ne peut pas dépasser 100 caractères")
    .regex(ALIAS_REGEX, 'Lettres minuscules, chiffres et tirets uniquement'),
  city: z.string().trim().min(1, 'La ville est requise').max(100, 'La ville ne peut pas dépasser 100 caractères'),
  department: z
    .string()
    .trim()
    .min(1, 'Le département est requis')
    .max(100, 'Le département ne peut pas dépasser 100 caractères'),
  region: z.string().trim().min(1, 'La région est requise').max(100, 'La région ne peut pas dépasser 100 caractères'),
  email: z
    .string()
    .trim()
    .min(1, "L'email du club est requis")
    .email('Adresse email invalide')
    .max(255, 'Email trop long'),
  phone: z.string().trim().max(15, 'Le téléphone ne peut pas dépasser 15 caractères').optional().or(z.literal('')),
});

export type ClubOnboardingFormData = z.infer<typeof clubOnboardingSchema>;
